<template>
    <div
        class="page-header page-header--transparent"
        :class="mode === 'wrapper' ? 'page-header--wrapper' : ''"
    >
        <div v-if="mode === 'fullScreen'">
            <div class="full-screen-wrapper">
                <img
                    class="ep-loader"
                    :src="require('@/assets/loader.svg')"
                    alt="logo"
                />
            </div>
        </div>
        <div
            v-else-if="mode === 'wrapper'"
            class="loading-wrapper-mode"
            :class="{ loading: isLoading }"
        >
            <div class="loader" :class="{ loading: isLoading }">
                <img
                    v-if="isLoading"
                    class="ep-loader"
                    :src="require('@/assets/loader.svg')"
                    alt="logo"
                />
                <slot name="loaderDescription" />
            </div>
            <div class="content" :class="{ loading: isLoading }">
                <slot />
            </div>
        </div>
        <div v-else-if="mode === 'default'" class="container">
            <div
                class="row align-items-center page-header__fullheight justify-content-center"
                :style="{ 'min-height': minHeight }"
            >
                <h5 v-if="text" v-text="text" />
                <div class="col-12 mx-auto text-center">
                    <img
                        class="ep-loader"
                        :src="require('@/assets/loader.svg')"
                        alt="logo"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PagePreloader',
    props: {
        mode: {
            type: String,
            default: 'default'
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        minHeight: {
            type: String,
            default: '70vh'
        },
        small: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: 'medium'
        },
        text: {
            type: String,
            default: ''
        }
    }
}
</script>

<style lang="scss">
.ep-loader {
    --size: 48px;
    width: var(--size);
    height: var(--size);

    &.small {
        --size: 24px;
    }

    &.big {
        --size: 64px;
    }
}
.page-header {
    .full-screen-wrapper {
        z-index: var(--z-index-page-loader);
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .loading-wrapper-mode {
        &.loading {
            position: relative;
        }
        .loader {
            &.loading {
                position: absolute;
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                z-index: var(--z-index-page-loader);
                background-color: rgba(255, 255, 255, 0.7);
                padding-top: 1rem;
            }
        }
        .content {
            transition: 0.3s;
            &.loading {
                filter: blur(2px);
                -webkit-filter: blur(2px);
            }
        }
    }
}
</style>
